import { forwardRef } from "react";
import { DataGrid as MuiDataGrid } from "@mui/x-data-grid";
import { makeStyles } from "@mui/styles";
import { mergeWith } from "lodash";

import { colors } from "theme";

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: "initial !important",
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      padding: "0 6px",
    },
    "& .MuiDataGrid-row": {
      "&.Mui-selected, &:hover": {
        backgroundColor: theme.palette.secondary.light,
      },
    },
    "& .MuiDataGrid-columnSeparator": { display: "none" },
    "& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-cell:focus-within":
      {
        outline: "none",
      },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 600,
    },

    "& .MuiDataGrid-cell": {
      paddingLeft: "16px !important",
      paddingRight: "13px !important",
      borderBottomColor: `${colors.grey[500]} !important`,
    },
    "& .MuiDataGrid-overlay": {
      backgroundColor: theme.palette.background.paper,
    },
  },
}));

const DataGrid = forwardRef(
  ({ classes = {}, ...otherProps }: any, ref: any) => {
    const baseClasses = useStyles();
    const dataGridClasses = mergeWith(
      baseClasses,
      classes,
      (class1: string, class2: string) => `${class1} ${class2}`
    );

    return (
      <MuiDataGrid
        ref={ref}
        filterMode="server"
        {...otherProps}
        classes={dataGridClasses}
      />
    );
  }
);

export default DataGrid;
